import React from 'react'

export default function Articles() {
  return (

    <section className="container-article">
      <div className="row">
        <div className="article">
          <h2>Article Title 1</h2>
          <img className="article-image" src="https://source.unsplash.com/640x480/?laptop" alt="" />
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsum
            debitis ut assumenda perspiciatis, iure necessitatibus omnis aut
            dolor nam tempore dolorum porro blanditiis earum eos modi quam,
            dolorem soluta. Quisquam.
   </p>
          <p>
            <span className="article-tag">Learn More</span>
          </p>
        </div>
        <div className="article">
          <h2>Article Title 2</h2>
          <img className="article-image" src="https://source.unsplash.com/640x480/?tech" alt="" />
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsum
            debitis ut assumenda perspiciatis, iure necessitatibus omnis aut
            dolor nam tempore dolorum porro blanditiis earum eos modi quam,
            dolorem soluta. Quisquam.
   </p>
          <p>
            <span className="article-tag">Learn More</span>
          </p>
        </div>
        <div className="article">
          <h2>Article Title 3</h2>
          <img className="article-image" src="https://source.unsplash.com/640x480/?code" alt="" />
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsum
            debitis ut assumenda perspiciatis, iure necessitatibus omnis aut
            dolor nam tempore dolorum porro blanditiis earum eos modi quam,
            dolorem soluta. Quisquam.
   </p>
          <p>
            <span className="article-tag">Learn More</span>
          </p>
        </div>
      </div>
    </section>
  )
}
